module.exports = __webpack_public_path__ + "static/media/5.8b388a91.jpg";